(function () {
  'use strict';

  angular
    .module('dashboard.employee.sales')
    .factory('DashboardEmployeeSales', dashboardEmployeeSales);

  dashboardEmployeeSales.$inject = ['$resource'];

  function dashboardEmployeeSales($resource) {
    return $resource(
      '/api/',
      {},
      {
        getData: {
          method: 'GET',
          url: '/api/dashboard/employees/sales/year/:year',
          isArray: true,
        },
      },
    );
  }
})();
